import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

const BundledPricing = ({ bundledPricing }) => (!bundledPricing ? null : (
  <ul className="pricing">
    <li>
      <span>Weighted Professional Bundled Price</span>
      {bundledPricing.weightedProfessional}
    </li>
    <li>
      <span>Weighted Technical Bundled Price</span>
      {bundledPricing.weightedTechnical}
    </li>
    <li>
      <span>Weighted Global Bundled Price</span>
      {bundledPricing.weightedGlobal}
    </li>
  </ul>
));

BundledPricing.propTypes = {
  bundledPricing: PropTypes.shape({
    weightedProfessional: PropTypes.string.isRequired,
    weightedTechnical: PropTypes.string.isRequired,
    weightedGlobal: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = ({ table }) => ({
  bundledPricing: table.bundledPricing,
});

export default connect(mapStateToProps)(BundledPricing);



// WEBPACK FOOTER //
// ./app/components/bundledPricing/index.js